import {FONDS} from "../fonds";
import DegradeFond from "./DegradeFond";

/**
 * Fonds animés proposés en plein écran pour le mode Publicité.
 * - ceux du bandeau (fonds/index.js) qui restent beaux agrandis à tout l'écran, vérifiés un par un sur l'écran vertical : ils
 *   reçoivent les mêmes images et réglages que dans le bandeau (carte « Fond du bandeau ») ; Matrix, Manettes, Voyageur et Oiseau
 *   sont dessinés pour les 112 px du bandeau et ne remplissent pas l'écran : ils ne sont pas proposés ;
 * - ceux propres au mode Publicité (dans ce dossier).
 */
const DU_BANDEAU = ["xmb", "veille95", "dvd", "nyan"];

export const FONDS_ANIMES = [
    {valeur: "degrade", libelle: "Dégradé aux couleurs d'AkitaTek", composant: DegradeFond},
    ...DU_BANDEAU.filter(id => FONDS[id]).map(id => ({valeur: id, libelle: FONDS[id].nom, composant: FONDS[id].composant})),
];

export const idsFondsAnimes = () => FONDS_ANIMES.map(f => f.valeur);

export const composantFondAnime = id => {
    const trouve = FONDS_ANIMES.find(f => f.valeur === id);
    return trouve ? trouve.composant : null;
};
